import { Injectable } from '@angular/core';
import { RedirectCommand, Resolve } from '@angular/router';

@Injectable()
export class EmailResolver implements Resolve<string | null | RedirectCommand> {
  email: string | null = null;

  resolve() {
    return this.email;
  }
}
